import React, { Component } from 'react';
import { Spin } from 'antd';
import CommonCharts from '../../../components/Charts';
import Fetch from '../../../../../common/Fetch';
import ExportUtil from '../../../../../common/ExportUtil';

class Charts extends Component {
    constructor(props) {
        super(props);
        this.state = {
            data: [],
            loading: false,
        };
    }

    shouldComponentUpdate(nextProps, nextState) {
        const { searchParams: nextSearchParams } = nextProps;
        const { searchParams } = this.props;
        if (nextSearchParams !== searchParams) {
            return false;
        }
        return true;
    }

    componentDidMount() {
        this.loadData();
    }
    
    componentDidUpdate(prevProps) {
        if (prevProps.load !== this.props.load) {
            this.loadData();
        }
    }

    loadData = () => {
        const { searchParams, queryUrl } = this.props;

        this.setState({ loading: true });
        Fetch.post(queryUrl, {
            ...searchParams,
        }).then(res => {
            const { datas: data } = res;
            this.setState({
                data,
                loading: false,
            });
        }).catch(err => {
            console.error(err);
            this.setState({ loading: false });
        });
    }

    handleClick = () => {
        const { searchParams, exportUrl } = this.props;
        ExportUtil.export({ ...searchParams, type: '1' }, null, exportUrl);
    }

    render() {
        const { height, filename } = this.props;
        const { data, loading } = this.state;
        const categories = [];
        const contractNumber = [];
        const contractAmount = [];
        (data || []).forEach(item => {
            const { customerBaName, jdeContractAmount, investigationNumber } = item;
            categories.push(customerBaName);
            contractNumber.push(investigationNumber || 0);
            contractAmount.push(jdeContractAmount || 0);
        });
        return (
            <Spin spinning={loading}>
                <CommonCharts
                    height={height}
                    filename={filename}
                    xAxis={{
                        categories,
                        crosshair: true
                    }}
                    yAxis={[{
                        allowDecimals: false,
                        title: {
                            text: '未登记请款的合同额含税(万元/人民币)',
                        },
                        opposite: true
                    }, {
                        allowDecimals: false,
                        title: {
                            text: '未登记请款的合同数',
                        }
                    }]}
                    series={[{
                        name: '未登记请款的合同数',
                        type: 'column',
                        yAxis: 1,
                        color: '#6b95f2',
                        data: contractNumber,
                    }, {
                        name: '未登记请款的合同额含税',
                        type: 'spline',
                        color: '#687794',
                        data: contractAmount,
                        tooltip: {
                            valueSuffix: ' 万元/人民币'
                        }
                    }]}
                    onClick={this.handleClick}
                />
            </Spin>
        );
    }
}

export default Charts;


// WEBPACK FOOTER //
// ./src/components/RequestDataAnalysis/RequestToDo/UnregisterRequest/HistogramBrokenLine/Charts.js